import { format, parseISO, parse } from 'date-fns';

const dateFormat = 'MMMM d, yyyy';

export const formatDateObject = (
  date: Date,
  formatString: string = dateFormat
) => {
  return format(date, formatString);
};

export const formatDateString = (
  dateString: string,
  formatString: string = dateFormat
) => {
  const date = new Date(dateString);
  return formatDateObject(date, formatString);
};

export const ensureFourDigitYear = (dateString: string) => {
  const chunks = dateString.split('/');
  let year = chunks[2];
  if (year) {
    if (year.length === 2) {
      year = `20${year}`;
    }
  } else {
    year = new Date().getFullYear().toString();
  }
  dateString = `${chunks[0]}/${chunks[1]}/${year}`;
  return dateString;
};

export const parseDateFromString = (
  dateString: string,
  formatString: string
) => {
  return parse(dateString, formatString, new Date());
};

export const formatISODate = (date?: string) => {
  if (date) {
    const parsed = parseISO(date);
    return format(parsed, dateFormat);
  }
  return date;
};
